import { LinearProgress, makeStyles } from '@material-ui/core';
import { useLoading } from 'react-admin';
import { FC } from 'react';
import { CRM_COLORS } from '../../../theme/crmColors';

const useStyles = makeStyles(() => ({
    wrapper: {
        // Avoid IE bug with Flexbox, see #467
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        position: 'relative',
        WebkitBoxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        boxSizing: 'border-box',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: CRM_COLORS.background,
    },
    mainWithoutAppbar: {
        position: 'relative',
        WebkitBoxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: CRM_COLORS.background,
    },
    body: {
        position: 'relative',
        WebkitBoxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 auto',
    },
    content: {
        position: 'relative',
        flex: 1,
        overflowX: 'hidden',
        backgroundColor: CRM_COLORS.background,
    },
    loader: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 1200,
    },
    leftContainer: {
        position: 'relative',
        top: '0',
        left: '0',
        width: '220px',
        height: '85vh',
        marginRight: '5px',
    },
    leftSidebar: {
        position: 'fixed',
        top: '100',
        left: '0',
        width: '220px',
        marginRight: '5px',
        marginLeft: '24px',

        height: '85vh',
    },
    drawerSideContainer: {
        position: 'absolute',
    },
    divBackButton: {
        backgroundColor: CRM_COLORS.primaryDark,
    },
    backArrow: {
        color: 'white',
    },
}));
const Layout: FC = (props) => {
    const classes = useStyles();
    const loading = useLoading();

    return (
        <div className={classes.wrapper}>
            <div className={classes.main}>
                <div className={classes.content}>{props.children}</div>
                {loading && (
                    <LinearProgress className={classes.loader} />
                )}
            </div>
        </div>
    );
};

export default Layout;
